exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dialog-actions{\n  min-height: 64px;\n  z-index: 1;\n  background: rgba(0, 0, 0, 1);\n}\n\n.dialog-title{\n  z-index: 1;\n  width: 100%;\n  color: white;\n  background: rgba(0, 0, 0, 1);\n}\n\n.dialog-title *{\n  color: inherit !important;\n}\n\n.dialog-actions svg,\n.dialog-title svg{\n  color: white;\n}\n", ""]);

